import { render, staticRenderFns } from "./Gpm.vue?vue&type=template&id=54530739&"
import script from "./Gpm.vue?vue&type=script&lang=js&"
export * from "./Gpm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports